import { CDN } from '../cdn/cdn'

let features = {}

export const featureToggleManager = (() => {
  const toggleFeature = (featureId = '', isActive = false) => {
    features[featureId].active = isActive
    localStorage.setItem('features', JSON.stringify(features))
  }

  const isFeatureActive = featureId => features[featureId]?.active || CDN.getCdnUrl().includes('green')

  const loadFeatures = async cdnUrl => {
    if (['/', 'localhost', '3000', 'green'].includes(cdnUrl)) {
      const FeaturesMap = (await import('./features.json')).default

      features = {
        ...FeaturesMap,
        ...(JSON.parse(localStorage.getItem('features')) || {})
      }

      window.featureToggle = {
        toggleFeature,
        isFeatureActive
      }
    }
  }

  return {
    loadFeatures,
    toggleFeature,
    isFeatureActive
  }
})()
